import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackMetaDefaultAccountChanged.meta';

export const useTrackMetaDefaultAccountChanged = () => {
  const { track } = useAnalyticsUtilities();

  const trackMetaDefaultAccountChanged = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackMetaDefaultAccountChanged };
};
